/*
 * The eyebrow above a value in a rail card — "Part of", "Has part", "owner".
 *
 * `mock-spec.txt` defines the eyebrow as 11/600 at 0.03em tracking, which is
 * what the Cmd-K group headings and the TechDocs reader rail use. Shared from
 * one place because it appears in two cards and would otherwise drift.
 *
 * Colour stays neutral-500 rather than the spec's lighter #9a9a9a: the weight
 * is what makes these read as eyebrows, and taking the tone lighter at the same
 * time would cancel that out.
 *
 * Deliberately unannotated: React's `CSSProperties` and MUI v4's JSS
 * `CreateCSSProperties` disagree on several longhand properties, so the
 * inferred literal type is the one both `makeStyles` calls accept.
 */
export const RAIL_EYEBROW = {
  fontSize: 11,
  fontWeight: 600,
  lineHeight: 1.4,
  letterSpacing: '0.03em',
  color: 'var(--bui-fg-secondary)',
};
